import React, { createContext, useContext } from 'react';

export interface AccordionContextType {
  id?: string;
  open: string | string[];
  toggle: (targetId: string, event: React.MouseEvent<HTMLButtonElement>) => void;
}
const AccordionContext = createContext<AccordionContextType>({} as AccordionContextType);

export const useAccordionContext = () => {
  return useContext(AccordionContext);
};

export default AccordionContext;
